export const docsByPatientProviderIdSelector = (
  { sessionData: { docs } },
  patientProviderId
) => docs[patientProviderId];

export const getDocByIdSelector = (
  { sessionData: { docs } },
  { patientProviderId, noteId }
) => (docs[patientProviderId] || []).find((d) => d.noteId === noteId);
